import { reversalCards } from "@/mocks/guatian";

export default function Reversal() {
  const [big, ...rest] = reversalCards;
  return (
    <section id="reversal" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-500/10 px-3 py-1.5 text-xs font-bold text-accent-700">
              <i className="ri-arrow-left-right-line" aria-hidden="true"></i>
              REVERSAL 反转档案
            </div>
            <h2 className="mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              反转档案 <span className="text-accent-600">实锤还是误读</span>
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-500">
              只收录经过多方比对、方向出现明显转向的节点，附上完整取证过程，让你看清楚一次反转是怎么发生的。
            </p>
          </div>
          <a
            href="#columns"
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-bold text-foreground-700 transition hover:border-accent-300 hover:text-accent-700"
          >
            查看全部档案
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-8 grid gap-5 lg:grid-cols-5">
          {/* 大图头条 */}
          <article className="group relative overflow-hidden rounded-lg lg:col-span-3">
            <div className="relative h-[320px] w-full md:h-[460px]">
              <img
                src={big.img}
                alt={big.alt}
                className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/25 to-transparent"></div>
              <div className="absolute right-4 top-4 rounded-md bg-accent-500 px-3 py-1.5 text-xs font-bold text-background-50">
                {big.stage}
              </div>
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                <span className="text-xs font-bold tracking-widest text-secondary-300">{big.no}</span>
                <h3 className="mt-2 text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                  {big.title}
                </h3>
                <p className="mt-3 max-w-xl text-sm leading-6 text-background-200/90">{big.lead}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-secondary-300 transition group-hover:gap-3">
                  展开完整取证链
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </article>

          {/* 右侧纵列 */}
          <div className="flex flex-col gap-5 lg:col-span-2">
            {rest.map((r) => (
              <article key={r.id} className="group flex flex-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition hover:border-accent-300 md:p-5">
                <div className="relative w-28 shrink-0 overflow-hidden rounded-md md:w-40">
                  <div className="relative h-full w-full min-h-[128px]">
                    <img
                      src={r.img}
                      alt={r.alt}
                      className="absolute inset-0 h-full w-full object-cover"
                    />
                  </div>
                </div>
                <div className="flex flex-col justify-center">
                  <span className="inline-flex items-center gap-2 text-xs font-bold text-accent-600">
                    <span className="rounded-sm bg-accent-100 px-1.5 py-0.5">{r.no}</span>
                    {r.stage}
                  </span>
                  <h3 className="mt-2 text-base font-bold leading-snug text-foreground-950 transition group-hover:text-accent-700">
                    {r.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-500">{r.lead}</p>
                </div>
              </article>
            ))}
            <a
              href="#columns"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-dashed border-background-300 py-4 text-sm font-bold text-foreground-500 transition hover:border-accent-300 hover:text-accent-700"
            >
              更多反转档案正在整理
              <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}